import { URLSearchParams } from 'url';
import {
  FdrCo2Footprint,
  FdrLink,
  FdrLinkType,
  FdrLinkOpenMethod,
} from '@hotelplan/supergraph-api';
import { addFdrGclIdQueryToJotformUrl } from 'components/domain/fdr-jotform';

const PRODUCT_INFORMATION_QUERY = 'wasErleben';
const PRODUCT_INFORMATION_QUERY_CONTACT_FORM = 'wasKonnen';
const DESTINATION_INFORMATION_QUERY = 'welcheDestinationen';
const DE_CONTACT_JOTFORM_LINK = 'https://form.jotform.com/221254405144344';
const FR_CONTACT_JOTFORM_LINK =
  'https://form.jotform.com/221254405144344?language=fr';

export const getFdrCo2FootprintJotformLink = (
  language: string,
  jotformQueryParams: URLSearchParams | null,
  gclId: string | undefined
): FdrLink => {
  const link =
    language === 'de' ? DE_CONTACT_JOTFORM_LINK : FR_CONTACT_JOTFORM_LINK;
  const url = new URL(addFdrGclIdQueryToJotformUrl(link, gclId));

  if (jotformQueryParams) {
    url.searchParams.append(
      PRODUCT_INFORMATION_QUERY_CONTACT_FORM,
      `${
        language === 'de' ? 'Nachhaltigkeit' : 'Durabilité'
      } - ${jotformQueryParams.get(PRODUCT_INFORMATION_QUERY)}`
    );

    url.searchParams.append(
      DESTINATION_INFORMATION_QUERY,
      jotformQueryParams.get(DESTINATION_INFORMATION_QUERY)
    );
  }

  return {
    type: FdrLinkType.External,
    openMethod: FdrLinkOpenMethod.Overlay,
    url: url.href.replaceAll('+', '%20'),
  };
};

export const getTotalEmission = (emission: number): string => {
  return emission.toString().replace('.', ',');
};

export const getIsShowCo2Footprint = (
  co2Footprint?: Omit<FdrCo2Footprint, 'totalEmission'>
): boolean => {
  const {
    accommodationEmissionPercentage,
    flightEmissionPercentage,
    transportEmissionPercentage,
    specialitiesEmissionPercentage,
  } = co2Footprint || {};

  return !!(
    accommodationEmissionPercentage ||
    specialitiesEmissionPercentage ||
    flightEmissionPercentage ||
    transportEmissionPercentage
  );
};
